import { apiService } from '@/services/APIService';
import { CRUDFactory } from '../CRUDFactory';

const namespace = 'client-question-groups';
export const CRUDGroups = CRUDFactory('client-question-groups');
export default {
  answer(id, params) {
    return apiService.post(`/${namespace}/${id}/answer`, params);
  },
  detach(id, params) {
    return apiService.post(`/${namespace}/${id}/detach-client-question`, params);
  },
  attach(id, params) {
    return apiService.post(`/${namespace}/${id}/attach-client-question`, params);
  },
};
